import { TableModel } from '@leverege/ui-attributes'
import ModelUtil from '@leverege/model-util'

const TYPE = 'ps.Alerts'

function create() {
  return {
    type : TYPE,
    table : TableModel.create()
  }
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'table' )
}
